import React, { useReducer, createContext } from 'react';
import {
  REQUEST_SUBMITTED,
  SET_HISTOGRAM_DATA,
  API_ERROR,
  SET_SUMMARY_DATA_FA,
  SET_TREND_DATA,
  SET_SUMMARY_DATA_LA,
  SET_ASIN_DATA,
  SET_ASIN_HISTORY_LA,
  SET_ASIN_HISTORY_FA,
  SET_PCOGS_SOURCE_FA,
  SET_PCOGS_SOURCE_LA,
  SET_RUN_ASIN_ANALYSIS,
  SCROLL_TO_REF,
} from '../actions/actionTypes';
import { extractErrorMessage } from '../../../utilities.js';
import logger from '../../../utils/logging.js';

const initialState = {
  requestSubmitted: false,
  showAsinAnalysis: false,
  request: null,
  histogramData: null,
  summaryDataFA: null,
  summaryDataLA: null,
  asinHistoryFA: null,
  asinHistoryLA: null,
  pcogsSourceFA: null,
  pcogsSourceLA: null,
  trendData: null,
  asinData: null,
  currentExecutionId: null,
  currentNextToken: null,
  currentBin: null,
  currentComponent: null,
  currentSource: null,
  currentHeader: null,
  flashbarItem: null,
  flashbarIdCount: 0,
};

const scrollToRef = (ref) => {
  if (ref && ref.current) {
    ref.current.scrollIntoView({ behavior: "smooth" })
  } 
}

export const StateContext = createContext(initialState);
export const DispatchContext = createContext(null);

// TODO: move reducer to separater folder
const reducer = (state, action) => {
  switch (action.type) {
    case REQUEST_SUBMITTED:
      return {
        ...state,
        requestSubmitted: true,
        showAsinAnalysis: false,
        request: action.payload,
        histogramData: null,
        summaryDataFA: null,
        summaryDataLA: null,
        trendData: null,
        asinHistoryFA: null,
        asinHistoryLA: null,
        pcogsSourceFA: null,
        pcogsSourceLA: null,
        asinData: null,
        executionId: null,
        nextToken: null,
        currentBin: null,
        currentComponent: null,
        currentSource: null,
      };
    case SCROLL_TO_REF: 
       scrollToRef(action.payload.ref);
       return state;
    case SET_HISTOGRAM_DATA:
      return { ...state, histogramData: { ...state.histogramData, ...action.payload } };
    case SET_SUMMARY_DATA_FA:
      return { ...state, summaryDataFA: action.payload };
    case SET_SUMMARY_DATA_LA:
      return { ...state, summaryDataLA: action.payload };
    case SET_ASIN_HISTORY_FA:
      return { ...state, asinHistoryFA: action.payload };
    case SET_ASIN_HISTORY_LA:
      return { ...state, asinHistoryLA: action.payload };
    case SET_PCOGS_SOURCE_FA:
      return { ...state, pcogsSourceFA: action.payload };
    case SET_PCOGS_SOURCE_LA:
      return { ...state, pcogsSourceLA: action.payload };
    case SET_TREND_DATA:
      return { ...state, trendData: { ...state.trendData, ...action.payload } };
    case SET_RUN_ASIN_ANALYSIS:
      const { bin, component, source } = action.payload;
      return { ...state, showAsinAnalysis: true, currentBin: bin, currentComponent: component, asinData: null, currentSource: source };
    case SET_ASIN_DATA:
      const { resultData, executionId, nextToken, header } = action.payload;
      return {
        ...state,
        asinData: [...(state.asinData || []), ...resultData],
        currentExecutionId: executionId,
        currentNextToken: nextToken,
        currentHeader: header,
      };
    case API_ERROR:
      const { error, api } = action.payload;
      const errorMessage = extractErrorMessage(error);
      logger.error(`call API ${api} failed with message: ${errorMessage}`, error);

      const { flashbarIdCount } = state;
      const newId = flashbarIdCount + 1;
      const newItem = {
        header: `An error happened when calling API: ${api}. Please try again`,
        type: 'error',
        content: `${errorMessage}`,
        dismissible: true,
        // the onDismiss function needs to be define in contents.jsx
        id: newId,
      };
      return { ...state, flashbarIdCount: newId, flashbarItem: newItem };
    default:
      return state;
  }
};

export const SpotcpContextProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <DispatchContext.Provider value={dispatch}>
      <StateContext.Provider value={state}>{props.children}</StateContext.Provider>
    </DispatchContext.Provider>
  );
};



// WEBPACK FOOTER //
// ./src/components/spotcp/context/spotcp-context.jsx